import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LogoutButton } from "../Utility/AuthTokenRetrieve";
import "../Food/RecipeList.css";
import "./BabyTracker.css";
import {
  eventCategoryLabels,
  fetchBabySummary,
} from "./BabyTrackerShared";

const categoryLinks = [
  { label: "Diapers", to: "/baby-tracker/diapers", category: "diaper" },
  { label: "Feeding", to: "/baby-tracker/feeding", category: "feeding" },
  { label: "Sleep", to: "/baby-tracker/sleep", category: "sleep", summaryKey: "todaySleepLabel" },
];

const BabyTrackerHome = () => {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshSummary = () => {
    setLoading(true);
    fetchBabySummary()
      .then((data) => {
        setSummary(data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    refreshSummary();
  }, []);

  const todayCounts = summary?.todayCounts || {};
  return (
    <div className="BabyTrackerPage">
      <div className="searchBarDiv formViewWrapper BabyTrackerIntro">
        <div>
          <h2 className="BabyTrackerTitle">Baby tracker</h2>
          <p className="BabyTrackerSubtitle">
            Shared tracking for diapers, feeding, and sleep.
          </p>
        </div>
        <LogoutButton></LogoutButton>
      </div>

      <div className="BabyTrackerHomeImageWrap">
        <img className="BabyTrackerHomeImage" src="/lil_jon.jpeg" alt="Baby tracker" />
      </div>

      <div className="shoppingListDiv BabyTrackerPanel BabyTrackerSinglePanel">
        <h3>Today</h3>
        <div className="BabyTrackerCategoryGrid">
          {categoryLinks.map((link) => (
            <Link
              className="summaryButton BabyTrackerCategoryButton"
              key={link.to}
              to={link.to}
            >
              <strong>{link.label}</strong>
              <span>
                {link.summaryKey ? summary?.[link.summaryKey] || "0m asleep" : `${todayCounts[link.category] || 0} today`}
              </span>
            </Link>
          ))}
        </div>
        {summary?.todayFeedingOunces ? (
          <p className="BabyTrackerStatus">{summary.todayFeedingOunces} oz logged today.</p>
        ) : null}
      </div>

      {loading ? <div className="shoppingListDiv BabyTrackerPanel">Loading baby data...</div> : null}

      <div className="shoppingListDiv BabyTrackerPanel BabyTrackerSinglePanel">
        <h3>Recent events</h3>
        {summary?.recentEvents?.length ? (
          summary.recentEvents.slice(0, 6).map((entry) => (
            <div className="BabyTrackerHistoryRow" key={entry.id}>
              <div>
                <strong>{entry.eventType}</strong>
                <div>{eventCategoryLabels[entry.eventCategory]}</div>
              </div>
              <span>{entry.occurredAt}</span>
            </div>
          ))
        ) : (
          <p>No baby events logged yet.</p>
        )}
      </div>
    </div>
  );
};

export default BabyTrackerHome;
